import s from "./styles.module.scss";
import chevronDownIcon from "../../assets/chewron_down.svg";

const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total is less than or equal to max visible
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show pages around current page
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

      // Adjust start page if we're near the end
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  return (
    <div className={s.coursesPagination}>
      <button
        className={s.paginationNav}
        onClick={handlePrevious}
        disabled={currentPage === 1}
      >
        <img
          src={chevronDownIcon}
          alt="Previous"
          className={`${s.chevronIcon} ${s["chevronIcon--left"]}`}
        />
        <span>Previous</span>
      </button>

      <div className={s.paginationNumbers}>
        {getPageNumbers().map((page) => (
          <button
            key={page}
            className={`${s.paginationNumber} ${
              currentPage === page ? s["paginationNumber--active"] : ""
            }`}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        className={s.paginationNav}
        onClick={handleNext}
        disabled={currentPage === totalPages}
      >
        <span>Next</span>
        <img
          src={chevronDownIcon}
          alt="Next"
          className={`${s.chevronIcon} ${s["chevronIcon--right"]}`}
        />
      </button>
    </div>
  );
};

export default Pagination;
